var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgProIcon = function SvgProIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pro-icon_svg__Layer_3",
    viewBox: "0 0 155.8 175.1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".pro-icon_svg__st2{fill:#8c33da}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107 175.1l43.7-44.8c3.7-3.8 5.4-8.8 5.1-13.8 0-.4-.1-.8-.1-1.2H107v59.8z",
    fill: "#5fb3dd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8.4L5.1 45.2C1.4 49-.3 54 0 59c0 .4.1.7.1 1.1h48.6V.4z",
    fill: "#e2735d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "pro-icon_svg__st2",
    d: "M48.8 115.3zM107 60.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1565d",
    d: "M48.8 60.1v55.2H107V60.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#47a0dd",
    d: "M48.8 115.3l58.2 59.8v-59.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef9856",
    d: "M107 60.1L48.8.4v59.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "pro-icon_svg__st2",
    d: "M107 60.1v55.2h48.6c-.5-3.8-2.1-7.5-4.9-10.4L107 60.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8 115.3V60.1H.2c.5 3.8 2.1 7.5 4.9 10.4l43.7 44.8z",
    fill: "#ea75d4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M154.3 8.5c3.1-3.2.9-8.5-3.6-8.5H62.3l50.3 51.5 41.7-43z",
    fill: "#eabd59"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 166.8C-1.7 170 .6 175 5 175h88.5l-50.3-51.4-41.7 43.2z",
    fill: "#49cbce"
  })));
};
export default SvgProIcon;